import {useContext} from 'react'

import Spinner, {atomSpinnerOverlayTypes} from '@s-ui/react-atom-spinner'
import Context from '@s-ui/react-context'

const LoadingPage = () => {
  const {i18n} = useContext(Context)

  return (
    <div className="mt-UserProfileComplete-loading">
      <Spinner overlayType={atomSpinnerOverlayTypes.TRANSPARENT} />
      <span className="mt-UserProfileComplete-loadingText">{i18n.t('RESERVATION_C2B.USER_FORM.LOADING_TEXT')}</span>
    </div>
  )
}

LoadingPage.displayName = 'LoadingPage'
LoadingPage.propTypes = {}

export default LoadingPage
